
const USERINFO = 'userInfo'

let AUTH_MEMO = null

export const setAuth = (auth) => {
  AUTH_MEMO = { ...auth }
  // localStorage.setItem(USERINFO, JSON.stringify(auth))
  localStorage.setItem(USERINFO, JSON.stringify(auth))
}

export const getAuth = () => {
  if (!AUTH_MEMO) {
    // AUTH_MEMO = JSON.parse(localStorage.getItem(USERINFO) || '{}')
    AUTH_MEMO = JSON.parse(localStorage.getItem(USERINFO) || '{}')
  }
  return AUTH_MEMO
}

export const getToken = () => getAuth()?.token

// export const clearAuth = () => localStorage.removeItem(USERINFO)
// export const clearAuth = () => sessionStorage.removeItem(USERINFO)
export const clearAuth = () => localStorage.clear()


